import { createSelector } from 'reselect';
import get from 'lodash/get';

import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';

export const selectEditStaffDomain = state => state.EditStaff || initialState;

const selectStaff = () => createSelector(selectEditStaffDomain, subState => get(subState, 'staff', []));

const selectStaffUpdating = () => createSelector(selectEditStaffDomain, subState => get(subState, 'staffUpdating', []));

const selectStaffSuggestionsOptions = () =>
  createSelector(selectEditStaffDomain, subState =>
    createSelectFieldOptions(get(subState, `${initialState.staffSuggestions.listName}.data`, []), 'id', 'name'),
  );

const selectStaffSuggestionsLoading = () =>
  createSelector(selectEditStaffDomain, subState =>
    get(subState, `${initialState.staffSuggestions.listName}.loading`, false),
  );

export { selectStaffSuggestionsOptions, selectStaffSuggestionsLoading, selectStaff, selectStaffUpdating };
